<template>
    <tr class="tableTr">
        <td :class="{'tdGreen': checkClasses['filter_truck_number']}">{{ item['truck_number'] }}</td>
        <td width="170" class="center dense" :class="{'tdGreen': checkClasses['filter_company_owned']}">
            <svg-sprite
                :style="`color: ${ Boolean(item.company_owned) ? '#19BC38' : '#8F90A6'}`"
                height="20"
                width="20"
                :icon-id="`st_${item.company_owned ? 'true': 'false'}`"
            ></svg-sprite>
        </td>
        <td class="dense" :class="{'tdGreen': checkClasses['filter_customer']}">{{ item['customer'] }}</td>
        <td :class="{'tdGreen': checkClasses['filter_driver']}">{{ item['driver'] }}</td>
        <td :class="{'tdGreen': checkClasses['filter_driver_type']}">{{ item['driver_type'] }}</td>
        <td :class="{'tdGreen': checkClasses['filter_reason']}">
            <span class="colorTd" :style="`background: ${item.color}`"></span>
            {{ item['reason'] }}
        </td>
        <td :class="{'tdGreen': checkClasses['filter_description']}">{{ item['description'] }}</td>
    </tr>
</template>

<script>
import { mapActions } from "vuex";
import formatDate from "@/helper/formatDate";

export default {
	name: "TableTr",
	props: {
		item: Object,
		permissions: Object,
		checkClasses: Object,
		filterClassesActive: Function,
		idx: Number
	},
	/*    computed: {
            getIndicatorColor() {
                const item = this.reason.find(item => item.id === this.item['reason_id']);
                return item?.color ?? '';
            }
        },*/
	methods: {
		...mapActions([ 'onTrucksRoadEditDynamic' ]),
		onFormatDate(date) {
			return formatDate(date);
		}
	}
};
</script>

<style lang="scss" scoped>
@import "motivationInfoTableTR";
</style>

<style lang="scss">
@import "motivationInfoTableTRAll";
</style>
